import { ElemTypes, IElement } from 'common/interfaces';

import { MIXED_COLOR_VALUE } from './ElemColorSettings.constants';

export const getInitialColor = (selectedElems: IElement[]): string => {
  if (selectedElems.length === 0) return '#fff';

  const selectedBlockElems = selectedElems.filter(
    (item) => item.elemType === ElemTypes.BLOCK,
  );

  const isMixedColor =
    selectedBlockElems.length > 1 &&
    new Set(selectedElems.map((elem) => elem.styles.background)).size !== 1;

  if (isMixedColor) return MIXED_COLOR_VALUE;

  return String(selectedBlockElems[0]?.styles.background) ?? '';
};
